import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/PlatinumLemonCherryGelato/ProductShowcase";
import Navbar from "../../components/Navbar";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import Footer from "../../components/Footer";
import { Helmet } from "react-helmet";

const PlatinumLemonCherryGelato = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Helmet>
        <title>Platinum Lemon Cherry Gelato - Zesty Citrus & Smooth Effects | BeyondBloom™</title>
        <meta
          name="description"
          content="Platinum Lemon Cherry Gelato is a premium strain with a zesty lemon-cherry flavor and smooth, balanced effects."
        />
        <meta
          name="keywords"
          content="Platinum Lemon Cherry Gelato, citrus strain, cherry cannabis, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Platinum Lemon Cherry Gelato - Zesty Citrus & Smooth Effects | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Platinum Lemon Cherry Gelato is a premium strain with a zesty lemon-cherry flavor and smooth, balanced effects."
        />
        <meta property="og:image" content="/images/platinum-lemon-cherry-gelato.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/platinum-lemon-cherry-gelato" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Platinum Lemon Cherry Gelato - Zesty Citrus & Smooth Effects | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Platinum Lemon Cherry Gelato is a premium strain with a zesty lemon-cherry flavor and smooth, balanced effects."
        />
        <meta name="twitter:image" content="/images/platinum-lemon-cherry-gelato.png" />
      </Helmet>

      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />{" "}
    </>
  );
};

export default PlatinumLemonCherryGelato;
